






import { Component, Vue } from "vue-property-decorator";
import LogoutCard from "../components/LogoutCard.vue";

@Component({
  components: { LogoutCard }
})
export default class Logout extends Vue {}
